import React, { useState, useEffect } from 'react';
import {
    Table,
    Card,
    Input,
    Space,
    App
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { usePageTitle } from '../context/PageTitleContext';
import { securityService } from '../services/api';

const AuthBlockLogs = () => {
    const { setPageTitle } = usePageTitle();
    const { message } = App.useApp();
    const [logs, setLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        setPageTitle('Логи блокировок');
        fetchAuthBlockLogs();
    }, []);

    useEffect(() => {
        if (logs.length > 0) {
            filterLogs(searchText);
        }
    }, [searchText, logs]);

    const fetchAuthBlockLogs = async () => {
        try {
            setLoading(true);
            const response = await securityService.getAuthBlockLogs();
            if (response && response.status === 'success') {
                setLogs(response.data);
                setFilteredLogs(response.data);
            } else {
                message.error(response?.message || 'Не удалось загрузить логи блокировок');
            }
        } catch (error) {
            message.error(error.response?.data?.message || 'Ошибка при загрузке логов');
            console.error('Error fetching block logs:', error);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Не указано';
        const date = new Date(dateString);
        return date.toLocaleString('ru-RU', {
            timeZone: 'UTC',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    const filterLogs = (value) => {
        const searchValue = value.toLowerCase();
        const filtered = logs.filter(log =>
            log.username.toLowerCase().includes(searchValue) ||
            log.ip_address.includes(searchValue)
        );
        setFilteredLogs(filtered);
    };

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 70,
            sorter: (a, b) => a.id - b.id,
        },
        {
            title: 'Пользователь',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: 'IP-адрес',
            dataIndex: 'ip_address',
            key: 'ip_address',
        },
        {
            title: 'Тип блокировки',
            dataIndex: 'block_type',
            key: 'block_type',
            filters: [
                { text: 'Пользователь', value: 'user' },
                { text: 'IP', value: 'ip' }
            ],
            onFilter: (value, record) => record.block_type === value,
            render: (type) => {
                const typeMap = {
                    'user': 'Пользователь',
                    'ip': 'IP'
                };
                return typeMap[type] || type;
            }
        },
        {
            title: 'Дата создания',
            dataIndex: 'created_at',
            key: 'created_at',
            render: formatDate,
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
        },
        {
            title: 'Заблокирован до',
            dataIndex: 'blocked_until',
            key: 'blocked_until',
            render: formatDate,
            sorter: (a, b) => new Date(a.blocked_until) - new Date(b.blocked_until),
        },
    ];

    return (
        <Card>
            <div style={{ marginBottom: 16 }}>
                <Input
                    placeholder="Поиск по логину или IP"
                    prefix={<SearchOutlined />}
                    value={searchText}
                    onChange={handleSearch}
                    style={{ width: 300 }}
                    allowClear
                />
            </div>
            <Table
                columns={columns}
                dataSource={filteredLogs}
                rowKey="id"
                loading={loading}
                pagination={{
                    pageSizeOptions: [10, 20, 50, 100],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} из ${total} записей`
                }}
                size="middle"
                bordered
            />
        </Card>
    );
};

export default AuthBlockLogs;